import _ from "lodash";
import h from "../core/createElement";
import { just_numbers_input, switchable_element } from "../utils";


export default function Input({
    title, type = "text", items = [], shared = {}, name = "input", containerClass, onKeydown, onKeyup,
    placeholder = "", onChange, bindObject = {}, transformValue
}) {
    let container, invalid_timeout;

    const
        default_transform = () => {
            switch (type) {
                case "boolean-select": return element.value == 'true' ? true : false
                case "numeric": return +element.value ?? null;
                case "integer": return +element.value;
                case "select":
                default: return element.value;
            };
        },
        get_value = () => transformValue ? transformValue(element.value, default_transform) : default_transform(),
        change_bind_value = (e) => bindObject[name] = get_value(),
        _key_up = (e) => { change_bind_value(e); onKeyup && onKeyup(e) },
        _change = (e) => { change_bind_value(e); onChange && onChange(e) };


    const
        subtitle = switchable_element(<span class="subtitle"></span>),
        element = (() => {
            switch (type) {
                case "select": return (
                    <select onChange={_change}>
                        <option value="" selected disabled>-- selecione --</option>
                        {_.map(items, e => <option value={e.value}>{e.label}</option>)}
                    </select>
                )
                case "boolean-select": return (
                    <select onChange={_change}>
                        <option value="true">Verdadeiro</option>
                        <option value="false">Falso</option>
                    </select>
                )
                case "numeric": return (
                    <input
                        onKeyup={_key_up}
                        placeholder={placeholder}
                        onKeydown={e => {
                            just_numbers_input(e, '.')
                            if (e.key == '.' && e.target.value.includes(".")) e.preventDefault();
                            onKeydown && onKeydown(e);
                        }}
                    />
                )
                case "integer": return (
                    <input
                        onKeyup={_key_up}
                        placeholder={placeholder}
                        onKeydown={e => {
                            just_numbers_input(e)
                            onKeydown && onKeydown(e);
                        }}
                    />
                )
                default: return <input type={type} onKeydown={onKeydown} placeholder={placeholder} onKeyup={_key_up} />
            };
        })();


    shared[name] = {
        invalid: (bool) => {
            clearTimeout(invalid_timeout);

            if (bool) invalid_timeout = setTimeout(() => {
                container.classList.remove('invalid');
            }, 3000);

            container.classList[bool ? 'add' : 'remove']('invalid')
        },
        type,
        element,
        subtitle: (text) => {
            if (text) {
                subtitle.current().innerText = text;
                subtitle.show();
            } else {
                subtitle.current().innerText = "";
                subtitle.hide();
            }
        }
    };

    Object.defineProperty(shared[name], 'value', {
        get: () => get_value(),
        set: (v) => {
            switch (type) {
                case "boolean-select": element.value = _.isBoolean(v) ? `${v}` : "";
                    break;
                case "numeric": element.value = _.isNumber(v) ? `${v}` : "";
                    break;
                case "integer": element.value = _.isInteger(v) ? `${v}` : "";
                    break;
                case "select":
                default: element.value = v;
            };
            change_bind_value(element.value);
        }
    });

    return container = (
        <article class={"input " + (containerClass ? containerClass : "")}>
            <label>{title}</label>
            {element}
            {subtitle.marker()}
        </article>
    );
};